import { t } from 'i18next'

import { SelecaoProdutoPropostaValidadorBase } from '@/features/simulacao/utils/selecao-produto-proposta-validador-base'

export class SelecaoUnidadePropostaValidador extends SelecaoProdutoPropostaValidadorBase {
  validate() {
    if (this.simulacaoSelecionadaPossuiParcelaVencida()) {
      return t('proposta:selecao_produto.erros.parcelas_vencidas')
    }
    if (this.existeMaisDeUmaSimulacaoDoProdutoSelecionada()) {
      return t('proposta:selecao_produto.erros.produto_duplicado', {
        tipoProduto: this.textoDinamicoTipoProduto,
      })
    }
    return null
  }
}
